export const   CREDIT_CARD_TYPE= 'credit-card'
export const   BANK_ACCOUNT_TYPE= 'bank-account'
export const   STRIPE_CARD_TYPE= 'stripe-card'
